import React, {useState} from "react";
import {Button, Form, Grid, Header, Message, Segment} from 'semantic-ui-react'
import '../Login/Login.css'
import {useAuth} from "../../../lib/auth/useAuth";
import mustardBg from '../../../img/mustarddreams.png'
import MenuTopBar from "../../../components/Menu/MenuTopBar";
import { Link } from "react-router-dom";

function ResetPassword(props) {
  const params = new URLSearchParams(props.location.search);
  const uid = params.get('uid') || '';
  const token = params.get('token') || '';
  let [password, setPassword] = useState("");
  let [confirm, setConfirm] = useState("");
  let [done, setDone] = useState(false);
  let [error, setError] = useState(null);
  let [loading, setLoading] = useState(false);
  let auth = useAuth()

  const missingLink = !uid || !token;

  return (
    <div id={'login-page'}>
      <div id="dashboard">
        <MenuTopBar />
      </div>
      <img alt="" style={{ minWidth: '600px', width: '100%', height: '100%', position: 'absolute', left: '0', top: '20px' }} src={mustardBg} />
      <Grid textAlign='center' style={{height: '100vh'}} verticalAlign='middle'>
        <Grid.Column style={{maxWidth: 450}}>
          <Header as='h2' className={'white-text'} textAlign='center'>
          </Header>
          <Form size='large' className={'login-form'} onSubmit={ async () =>  {
            setError(null);
            if (password !== confirm) {
              setError('Passwords do not match.');
              return;
            }
            setLoading(true);
            let res = await auth.confirmPasswordReset(uid, token, password);
            setLoading(false);
            if (res.success) {
              setDone(true);
            } else {
              setError(res.error);
            }
          }}>
            <Segment basic stacked className={'login-form'}>
              {missingLink ? (
                <Message
                  negative
                  visible
                  header='Invalid reset link'
                  content='This link is missing its reset code. Use the link from your email, or request a new one.'
                />
              ) : done ? (
                <Message
                  positive
                  visible
                  header='Password updated'
                  content='Your password has been reset. You can now log in.'
                />
              ) : (
                <>
                  <Form.Input
                    fluid
                    icon='lock'
                    iconPosition='left'
                    placeholder='New password'
                    type='password'
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                  />
                  <Form.Input
                    fluid
                    icon='lock'
                    iconPosition='left'
                    placeholder='Confirm new password'
                    type='password'
                    value={confirm}
                    onChange={e => setConfirm(e.target.value)}
                  />
                  <Message
                    error
                    visible={!!error}
                    header='Could not reset password'
                    content={error}
                  />
                  <Button className={'login-btn'} color='blue' fluid size='large' type='submit' loading={loading} disabled={!password || !confirm || loading}>
                    Set New Password
                  </Button>
                </>
              )}
            </Segment>
          </Form>
          <Message>
            {done ? <Link to="/login">Log In</Link> : <>Need a new link? <Link to="/forgot-password">Request one</Link></>}
          </Message>
        </Grid.Column>
      </Grid>
    </div>
  )
}

export default ResetPassword;
